__turbopack_context__.v({
  "active": "NavBar-module-scss-module__4BfOFG__active",
  "bigLogo": "NavBar-module-scss-module__4BfOFG__bigLogo",
  "burgerButton": "NavBar-module-scss-module__4BfOFG__burgerButton",
  "buttonText": "NavBar-module-scss-module__4BfOFG__buttonText",
  "buttons": "NavBar-module-scss-module__4BfOFG__buttons",
  "de": "NavBar-module-scss-module__4BfOFG__de",
  "desktopLangToggle": "NavBar-module-scss-module__4BfOFG__desktopLangToggle",
  "drawerMenuLinks": "NavBar-module-scss-module__4BfOFG__drawerMenuLinks",
  "en": "NavBar-module-scss-module__4BfOFG__en",
  "grow": "NavBar-module-scss-module__4BfOFG__grow",
  "headerLarge": "NavBar-module-scss-module__4BfOFG__headerLarge",
  "headerSmall": "NavBar-module-scss-module__4BfOFG__headerSmall",
  "languageToggle": "NavBar-module-scss-module__4BfOFG__languageToggle",
  "link": "NavBar-module-scss-module__4BfOFG__link",
  "linkButton": "NavBar-module-scss-module__4BfOFG__linkButton",
  "logo": "NavBar-module-scss-module__4BfOFG__logo",
  "mobileLangToggle": "NavBar-module-scss-module__4BfOFG__mobileLangToggle",
  "patientButton": "NavBar-module-scss-module__4BfOFG__patientButton",
  "smallLogo": "NavBar-module-scss-module__4BfOFG__smallLogo",
  "tabs": "NavBar-module-scss-module__4BfOFG__tabs",
  "topBar": "NavBar-module-scss-module__4BfOFG__topBar",
});
